import { ActionReducerMap, createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromProducts from '@appStore/products/reducers/products.reducer';
import * as fromAgreements from '@appStore/products/reducers/agreement.reducer';
import * as fromRoot from '../../../reducers';

export interface ProductsState {
  products: fromProducts.State;
  agreements: fromAgreements.State;
}

export interface State extends fromRoot.State {
  products: ProductsState;
}

export const reducers: ActionReducerMap<ProductsState> = {
  products: fromProducts.reducer,
  agreements: fromAgreements.reducer
};

export const getState = createFeatureSelector<ProductsState>('products');

export const getProductsState = createSelector(
  getState,
  (state: ProductsState) => state.products
);

// Products
export const getTexts = createSelector(
  getProductsState,
  fromProducts.getTexts
);

export const getAllProducts = createSelector(
  getProductsState,
  fromProducts.getAll
);

export const getProductsLoaded = createSelector(
  getProductsState,
  fromProducts.getLoaded
);

export const getProductsLoading = createSelector(
  getProductsState,
  fromProducts.getLoading
);

export const getIsFi2XmlRegisteredOnCustomerLoaded = createSelector(
  getProductsState,
  fromProducts.getIsRegisteredLoaded
);

export const getIsFi2XmlRegisteredOnCustomer = createSelector(
  getProductsState,
  fromProducts.getIsRegistered
);

// Agreements
export const getAgreementState = createSelector(
  getState,
  (state: ProductsState) => state.agreements
);

export const getProductAgreementCreated = createSelector(
  getAgreementState,
  fromAgreements.getProductAgreementCreated
);

export const getProductAgreementCreatedId = createSelector(
  getAgreementState,
  fromAgreements.getProductAgreementCreateId
);

export const getActiveAgreementLoaded = createSelector(
  getAgreementState,
  fromAgreements.getActiveAgreementLinkLoaded
);

export const getActiveAgreementLink = createSelector(
  getAgreementState,
  fromAgreements.getActiveAgreementLink
);



